import React, { useState, useEffect } from "react";

export const ProgressBar = ({ width, percent }) => {
    const [value, setValue] = useState(0);

    useEffect(() => {
        setValue(percent);
    }, [percent]);

    return (
        <div className="progress-wrapper">
            <div className="progress">
                <div className="progress-bar" role="progressbar" style={{ width: `${value}%` }} aria-valuenow={`${value}`} aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        </div>
    );
};
